import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import { publicAssets } from '@utils/url.utils';
import { ROUTES } from '../../constants';
import {
    Background,
    Benefit,
    BenefitIcon,
    BenefitLabel,
    Benefits,
    Image,
    Price,
    PriceWithVat,
    Section,
    Title,
} from './Banner.elements';

export interface BannerProps {
    withoutImage?: boolean;
    withPrice?: boolean;
}

const BENEFIT_ITEM_KEYS = [
    'homepage.subscription.benefit1',
    'homepage.subscription.benefit2',
    'homepage.subscription.benefit3',
    'homepage.subscription.benefit4',
    'homepage.subscription.benefit5',
];

const BannerTemplate: FC<BannerProps> = ({ withoutImage, withPrice }) => {
    const { t } = useTranslations();

    const router = useRouter();

    return (
        <Background>
            <Title>{t('homepage.subscription.title')}</Title>
            <Section isStaticBanner>
                {!withoutImage && <Image isStaticBanner src={publicAssets('/rocne_profi.png')} />}
                <Benefits>
                    {BENEFIT_ITEM_KEYS.map((benefit, key) => (
                        <Benefit key={key}>
                            <BenefitIcon name={Icons.CheckThin} />
                            <BenefitLabel dangerouslySetInnerHTML={{ __html: t(benefit) }}></BenefitLabel>
                        </Benefit>
                    ))}
                    <Price>429 € bez DPH / rok</Price>
                    <PriceWithVat>527,67 € s DPH / rok</PriceWithVat>
                    <ButtonTemplate
                        onClick={() => router.push({ pathname: ROUTES.SUBSCRIPTION })}
                        fullWidth
                        marginTop={20}
                        marginBottom={20}
                        text={t('homepage.subscription.button')}
                    />
                </Benefits>
            </Section>
        </Background>
    );
};

export default BannerTemplate;
